import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVoipVideo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			rx: 32,
			fill: "#DDEAF1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.3227 22.284C38.888 22.8693 39.1867 23.6226 39.16 24.4066L39.1603 27.4645L44.7533 25.2067C45.8615 24.6526 47.1654 25.4585 47.1654 26.6974V37.304C47.1654 38.543 45.8615 39.3488 44.7533 38.7947L39.1611 36.5372L39.1614 39.636C39.1867 40.3906 38.8907 41.152 38.328 41.7333C37.7454 42.3346 36.952 42.6666 36.0947 42.6666H20.9227C19.248 42.6666 17.832 41.2786 17.832 39.636V24.3626C17.832 22.72 19.248 21.3333 20.9227 21.3333H36.0947C36.9254 21.3333 37.7374 21.68 38.3227 22.284ZM39.1608 33.5508L44.4987 35.686V28.3155L39.1606 30.4507L39.1608 33.5508ZM20.9227 40H36.0947C36.2748 40 36.5008 39.8883 36.4947 39.68V24.3626C36.4979 24.1264 36.2829 24 36.0947 24H20.9227C20.7054 24 20.4987 24.204 20.4987 24.3626V39.636C20.4987 39.7946 20.7054 40 20.9227 40Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgVoipVideo);
export { ForwardRef as ReactComponent };
